import { render, staticRenderFns } from "./DayReportFields.vue?vue&type=template&id=0d345050"
import script from "./DayReportFields.vue?vue&type=script&lang=js"
export * from "./DayReportFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports